var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row price-wrapper mx-0 w-100",class:_vm.classComponent},[(!_vm.item.prezzo)?_c('ResultsCardPriceTheDefault',{attrs:{"item":_vm.item,"is-card":_vm.isCard}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }